import React from 'react';
import { Flex, Text } from '@chakra-ui/react';
import { FooterPropTypes } from './FooterPropTypes';
import { Image } from '@chakra-ui/react';
import { Link } from 'gatsby-link';
import { localisable } from '../../generic/localisable';
import { CONSTANTS } from './constants';


export const Footer = ({ facilityName, syrasoftLogoLink, privacyPolicyLink }: FooterPropTypes.IFooterProps) => {
    const { PRIVACY_POLICY_LINK, SYRASOFT_LOGO_LINK } = CONSTANTS;
    return (
        <Flex
            bg="brand.primary"
            color='brand.secondary'
            padding={{ base: '16px 32px', lg: '16px 96px' }}
            justifyContent='center'
        >
            <Flex width={'100%'} maxW={'1092px'} justifyContent={'space-between'}>

                <Flex
                    direction={{ base: 'column' }}
                    alignItems={{ base: 'left' }}
                    width={'fit-content'}
                >
                    <Text textStyle='caption'>&copy; Copyright 2022 {facilityName} </Text>
                    <Link
                        to={privacyPolicyLink || PRIVACY_POLICY_LINK}
                    >
                        <Text textStyle='caption' color='text.footerLink' _hover={{ textDecoration: 'underline' }}>
                            {localisable.privacyPolicy}
                        </Text>
                    </Link>
                </Flex>
                <Flex direction='column' justifyContent='center'
                    width={'fit-content'}
                >
                    <Text textStyle='caption'> {localisable.poweredBy}</Text>
                    <a href='https://www.syrasoft.com/' target='_blank'>
                        <Image height='23px' width='87px' src={syrasoftLogoLink || SYRASOFT_LOGO_LINK} alt='Syrasoft Logo' />
                    </a>
                </Flex>
            </Flex>
        </Flex>
    )
};
